import React from 'react';

const FilePanelTitle = ({title}) => {
    return (
        <h4 className="upload-file__title">
            {title}
        </h4>
    );
};

export default FilePanelTitle;